import type { FunctionComponent, ReactNode } from "react";
import { Button } from "react-bootstrap";

interface Props {
  text?: string;
  icon?: ReactNode;
  variant:
    | "primary"
    | "secondary"
    | "success"
    | "info"
    | "warning"
    | "danger"
    | undefined;
  disabled?: boolean;
  callback: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const PortalButton: FunctionComponent<Props> = ({
  text,
  icon,
  variant,
  disabled,
  callback,
}) => {
  if (text && icon) {
    console.error("PortalButton supports either 'text' or 'icon', not both.");
    return null;
  }

  return (
    <div className="PortalButton">
      <Button
        variant={variant}
        disabled={disabled}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
          callback(event)
        }
      >
        <span className="d-flex align-items-center justify-content-center">
          {icon || (text && <span>{text}</span>)}
        </span>
      </Button>
    </div>
  );
};

export default PortalButton;
